import typeToReducer from 'type-to-reducer';
import {
  CHANGE_DATE_BY_TYPE,
  CHANGE_ACTIVE_TAB,
  FETCH_CASHBACK_LIST,
  SET_CURRENT_PAGE,
  CHANGE_ACTIVE_FILTER_BTN,
} from 'accountCashbackActions.js';
import { substractDays } from 'helpers/datesHelper.js';

let initialState = {
  isPending: true,
  error: null,
  startDate: substractDays(new Date(), 1),
  endDate: new Date(),
  activeTab: 'paid',
  cashback: {
    paid: {
      data: [],
      isNextPageAvailable: false,
      currentPage: 0,
    },
    awaiting: {
      data: [],
      isNextPageAvailable: false,
      currentPage: 0,
    },
    errorList: {
      data: [],
      isNextPageAvailable: false,
      currentPage: 0,
    },
  },
  limit: 5,
  filterBtnSelected: '',
};

export default typeToReducer(
  {
    [CHANGE_DATE_BY_TYPE]: (state, { payload: { dateType, date } }) => {
      return {
        ...state,
        cashback: {
          paid: {
            ...state.cashback.paid,
            currentPage: 0,
          },
          awaiting: {
            ...state.cashback.awaiting,
            currentPage: 0,
          },
          errorList: {
            ...state.cashback.errorList,
            currentPage: 0,
          },
        },
        [dateType]: date,
      };
    },
    [CHANGE_ACTIVE_TAB]: (state, { payload: { activeTab } }) => {
      return {
        ...state,
        cashback: {
          paid: {
            ...state.cashback.paid,
            currentPage: 0,
          },
          awaiting: {
            ...state.cashback.awaiting,
            currentPage: 0,
          },
          errorList: {
            ...state.cashback.errorList,
            currentPage: 0,
          },
        },
        activeTab,
      };
    },
    [SET_CURRENT_PAGE]: (state, { payload: { currentPage } }) => {
      return {
        ...state,
        cashback: {
          ...state.cashback,
          [state.activeTab]: { ...state.cashback[state.activeTab], currentPage },
        },
      };
    },
    [CHANGE_ACTIVE_FILTER_BTN]: (state, { payload: { filterBtnSelected } }) => {
      return { ...state, filterBtnSelected };
    },
    [FETCH_CASHBACK_LIST]: {
      PENDING: (state) => {
        return { ...state, isPending: true };
      },
      FAILURE: (state, { payload: { error } }) => {
        return { ...state, isPending: false, error };
      },
      SUCCESS: (state, { payload: { data, isNextPageAvailable } }) => {
        return {
          ...state,
          isPending: false,
          cashback: {
            ...state.cashback,
            [state.activeTab]: { ...state.cashback[state.activeTab], data, isNextPageAvailable },
          },
        };
      },
    },
  },
  initialState
);
